import React from 'react'
import Fragment from '../common/fragment'


function FragmentDK(props) {
  return (
    <Fragment pos="kkkk" {...props}>
      <p>
      Espejos humeantes:
        <br />
    • Tezcatlipoca
        <br />
    • Mancebos
        <br />
    • Algoritmos
        <br />
    • Ovejas
        <br />
    • Variables
        <br />
    • Tenochtitlan
        <br />
    • Epifanías
        <br />
    • Balidos
        <br />
    • Negromex
        <br />
    • Cielos oscuros
        <br />
    • Hule
        <br />
      </p>
    </Fragment>
  )
}


export default FragmentDK
